export default "__VITE_ASSET__7$mZNbzK__"